module.exports = __webpack_public_path__ + "static/media/quote_bottom.794961d3.svg";